<template>
  <div class="page-content">
    <div class="search-form" style="margin-top: 10px;">
      <div class="search-form-row">
        <div class="search-form-field">
          <div class="search-form-field-label">地区：</div>
          <div class="search-form-field-content">
            <collapse close-title="" open-title="">
              <div class="area-provinces-select">
                <div class="area-provinces-select-item" v-for="i in areaAndProvinces" :key="i.area" :style="{width:i.width}">
                  <div class="area-provinces-select-area">{{i.area}}：</div>
                  <tag-select class="area-provinces-select-provinces" :tags="i.provinces" v-model="i.selected" multiple></tag-select>
                </div>
              </div>
            </collapse>
          </div>
        </div>
      </div>
      <div class="search-form-row">
        <div class="search-form-field">
          <div class="search-form-field-label">内容：</div>
          <div class="search-form-field-content v-center">
            <el-input v-model="searchForm.keyword" style="width: 200px;" size="mini"></el-input>
          </div>
        </div>
        <div class="search-form-field">
          <div class="search-form-field-label">发字文号：</div>
          <div class="search-form-field-content v-center">
            <el-input v-model="searchForm.postNameLike" style="width: 200px;" size="mini"></el-input>
          </div>
        </div>
        <div class="search-form-field">
          <div class="search-form-field-label">时间：</div>
          <div class="search-form-field-content">
            <el-date-picker style="width: 250px;margin-left: 10px;" clearable
                            v-model="searchForm.dateRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期" size="small" unlink-panels
                            end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <div class="search-form-field">
          <div class="search-form-field-label">发布机构：</div>
          <div class="search-form-field-content v-center">
            <el-input v-model="searchForm.releaseByClassifyLike" style="width: 200px;" size="mini"></el-input>
          </div>
        </div>
      </div>
      <div class="search-form-row">
        <div class="search-form-field">
          <div class="search-form-field-label">类型：</div>
          <div class="search-form-field-content v-center">
            <tag-select :tags="['会展政策','奖励政策']" v-model="searchForm.usedState"></tag-select>
          </div>
        </div>
      </div>
      <div class="search-form-bottom">
        <el-button type="primary" @click="search">检索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <div style="background-color: #FFFFFF;padding: 20px;margin-top: 25px;" v-if="data">
      <el-table :data="content" stripe class="large-font-table" tooltip-effect="light">
        <el-table-column prop="title" label="政策标题" show-overflow-tooltip>
          <a class="link" slot-scope="{row}" :href="row.url" target="_blank">{{row.title}}</a>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="area" label="地区" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="source" label="来源站点" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="release_by_classify" label="发布机构" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="release_time" label="发布时间" width="120" show-overflow-tooltip>
          <span slot-scope="{row}">{{row.release_time.substring(0,10)}}</span>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" background
                     :total="data.totalElements" :current-page="data.number+1"
                     @current-change="loadData">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../api";
import TagSelect from "./TagSelect";
import moment from "moment";
import Collapse from "./Collapse";
const DATE_FMT='YYYY-MM-DD';

export default {
  name: "ZcfgListNew",
  components:{TagSelect,Collapse},
  data(){
    return {
      areaAndProvinces:[
        {
          area:"华东",
          provinces:["山东", "江苏", "上海", "浙江", "福建", "安徽", "江西"],
          selected:[],
          width:'40%',
        },
        {
          area:"华南",
          provinces:["广东", "广西", "海南"],
          selected:[],
          width:'30%',
        },
        {
          area:"西南",
          provinces:["四川", "云南", "重庆", "贵州", "西藏"],
          selected:[],
          width:'30%',
        },
        {
          area:"华北",
          provinces:["河北", "北京", "天津", "内蒙古", "山西"],
          selected:[],
          width:'40%',
        },
        {
          area:"西北",
          provinces:["陕西", "新疆", "甘肃", "青海", "宁夏"],
          selected:[],
          width:'30%',
        },
        {
          area:"华中",
          provinces:["湖南", "湖北", "河南"],
          selected:[],
          width:'30%',
        },
        {
          area:"东北",
          provinces:["辽宁", "吉林", "黑龙江"],
          selected:[],
          width:'40%',
        }
      ],
      searchForm:{
        dateRange:null,
        releaseByClassifyLike:null,
        keyword:null,
        postNameLike:null,
      },
      searchParams:{
        area:null,
        startDate:null,
        endDate:null,
        releaseByClassifyLike:null,
        keyword:null,
        postNameLike:null,
      },
      data: {
        "size": 10,
        "number": 0,
        "totalElements": 6,
        "totalPages": 1,
        "content": [
          {
            "data": {
              "id": "d80364a7bdf3b68ba7ae9b10d675d98c",
              "area": "山西",
              "source": "山西省商务厅",
              "title": "山西省商务厅关于2025年第二批会展业发展项目申报工作的补充通知",
              "url": "http://swt.shanxi.gov.cn/xxgk/xxgkzl/xxgklm/gztz_69874/202512/t20251215_10013277.shtml",
              "release_by": [
                "山西省商务厅"
              ],
              "type": "会展政策",
              "release_time": "2025-12-15 00:00:00",
              "release_by_classify": "商务部"
            }
          },
          {
            "data": {
              "id": "26e42eec258b65a487d94333a4eaedb2",
              "area": "山西",
              "source": "山西省商务厅",
              "title": "山西省商务厅关于公开征集第五届中国—蒙古国博览会会展服务单位的通知",
              "url": "http://swt.shanxi.gov.cn/xxgk/xxgkzl/xxgklm/gsxx/202507/t20250731_9928232.shtml",
              "release_by": [
                "山西省商务厅"
              ],
              "type": "会展政策",
              "release_time": "2025-07-31 00:00:00",
              "release_by_classify": "商务部"
            }
          },
          {
            "data": {
              "id": "c9f8fda241c76aa42fb916cd6c6c3ad4",
              "area": "成都市",
              "source": "成都市人民政府",
              "title": "成都高新区管委会关于印发《成都高新区关于促进会展业高质量发展的若干政策》的通知",
              "url": "http://www.cdht.gov.cn/gkml/xzgfxwj/1204374454751199233.shtml",
              "release_by": [
                "高新区国际合作商务局"
              ],
              "type": "会展政策",
              "release_time": "2024-01-29 00:00:00",
              "release_by_classify": null
            }
          },
          {
            "data": {
              "id": "5abf69045e4737d3dff6b7a6b4551346",
              "area": "广东",
              "source": "广东省深圳市",
              "title": "深圳市商务局关于征集2026年境外展会的通知",
              "url": "https://commerce.sz.gov.cn/xxgk/qt/tzgg_1/content/post_12472715.html",
              "release_by": [
                "广东省深圳市"
              ],
              "type": "会展政策",
              "release_time": "2025-11-04 00:00:00",
              "release_by_classify": "商务部"
            }
          },
          {
            "data": {
              "id": "848c0c92fd6f2f3b5d0ede21fa9f4ce4",
              "area": "宁夏",
              "source": "辽宁省大连市",
              "title": "大连市人民政府办公厅关于印发《大连市促进会展业高质量发展实施方案》的通知",
              "url": "https://www.dl.gov.cn/art/2024/12/31/art_5476_2393155.html",
              "release_by": [
                "辽宁省大连市"
              ],
              "type": "会展政策",
              "release_time": "2024-12-31 00:00:00",
              "release_by_classify": "商务部"
            }
          },
          {
            "data": {
              "id": "1aa4e03f547a129547121ed923b8f125",
              "area": "广州市",
              "source": "广州市商务厅",
              "title": "广州市商务局关于转发2024年广东省会展企业百强和会展项目百强认定工作的通知",
              "url": "https://sw.gz.gov.cn/gkmlpt/content/9/9696/post_9696029.html#147",
              "release_by": [
                "广州市商务厅"
              ],
              "type": "会展政策",
              "release_time": "2024-06-07 00:00:00",
              "release_by_classify": "商务部"
            }
          },
          {
            "data": {
              "id": "8e9ac2ed7860b3b12e5b76c01f0af014",
              "area": "海南",
              "source": "海南省商务厅",
              "title": "海南省商务厅关于印发《海南省推动会展业高质量发展财政奖励实施细则操作指引》的函",
              "url": "https://dofcom.hainan.gov.cn/dofcom/0400/202509/1003fb83658d4734a1fa726ed98f1903.shtml?ddtab=true",
              "release_by": [
                "海南省商务厅"
              ],
              "type": "奖励政策",
              "release_time": "2025-09-19 00:00:00",
              "release_by_classify": "商务部"
            }
          },
          {
            "data": {
              "id": "834b40072ace6c75690f9fe00513a165",
              "area": "海南",
              "source": "海南省财政厅",
              "title": "海南省财政厅  海南省商务厅关于印发《海南省支持会展业发展资金管理办法》的通知",
              "url": "https://mof.hainan.gov.cn/sczt/zcfg/202008/de938202660d424898b59ac6cc2f7616.shtml?ddtab=true",
              "release_by": [
                "海南省财政厅"
              ],
              "type": "奖励政策",
              "release_time": "2020-07-27 00:00:00",
              "release_by_classify": "财政部"
            }
          },
          {
            "data": {
              "id": "fb144ff182ba3542c7797bf5f7315a16",
              "area": "海南",
              "source": "海南省商务厅",
              "title": "关于邀请竞标2025年度省级会展项目审计审查及绩效评价服务项目的函",
              "url": "https://dofcom.hainan.gov.cn/dofcom/0400/202506/9c613b51b8474c83b6b1a7437ec26f70.shtml?ddtab=true",
              "release_by": [
                "海南省商务厅"
              ],
              "type": "奖励政策",
              "release_time": "2025-06-09 00:00:00",
              "release_by_classify": "商务部"
            }
          }
        ]
      }
    }
  },
  created() {
    this.init()
  },
  computed:{
    content(){
      return this.data?this.data.content.map(i=>i.data):[]
    }
  },
  methods:{
    async init(){
      await this.search()
    },
    async search(){
      const province=this.areaAndProvinces.reduce((acc,v)=>{
        acc.push(...v.selected)
        return acc
      },[])
      if(province.length===0){
        this.searchParams.area=null
      }else{
        this.searchParams.area=province
      }
      if (this.searchForm.dateRange) {
        this.searchParams.startDate = moment(this.searchForm.dateRange[0]).format(DATE_FMT)
        this.searchParams.endDate = moment(this.searchForm.dateRange[1]).format(DATE_FMT)
      }else{
        this.searchParams.startDate = null
        this.searchParams.endDate = null
      }
      this.searchParams.releaseByClassifyLike=this.searchForm.releaseByClassifyLike
      this.searchParams.keyword=this.searchForm.keyword
      this.searchParams.postNameLike=this.searchForm.postNameLike
      await this.loadData(1)
    },
    async reset(){
      this.areaAndProvinces.forEach(i=>i.selected=[])
      this.searchForm.dateRange=null
      this.searchForm.releaseByClassifyLike=null
      this.searchForm.keyword=null
      this.searchForm.postNameLike=undefined
    },
    async loadData(page){
      (await api.listZcwj({...this.searchParams,page:page-1,size:10})).data
      console.log(page)
    }
  }
}
</script>

<style scoped>

</style>
